import { Component, OnInit, inject } from '@angular/core';
import {ProfileDataService} from '../profile-data.service';
import { GrowOutAnimation, OpacityInAnimation, ExpandableComponent, HtmlSanitizePipe } from '@exl-ng/mulo-common';
import {ProfileAssetDisplayEnrichmentService} from '../profile-asset-display-enrichment.service';
import {UrlUtils} from '../../shared/utils/url.utils';
import { TranslateModule } from '@ngx-translate/core';
import { CitationBriefComponent } from '../../parts/citations/citation-brief/citation-brief.component';


@Component({
    selector: 'esp-profile-highlights',
    templateUrl: './profile-highlights.component.html',
    styleUrls: ['./profile-highlights.component.scss'],
    animations: [
        GrowOutAnimation,
        OpacityInAnimation
    ],
    imports: [CitationBriefComponent, ExpandableComponent, TranslateModule, HtmlSanitizePipe]
})
export class ProfileHighlightsComponent implements OnInit {
    profileDataService = inject(ProfileDataService);
    profileAssetEnrichmentService = inject(ProfileAssetDisplayEnrichmentService);


    institutionCode = UrlUtils.getParam('institution');

    ngOnInit() {
        this.enrichHighlightsData();
    }

    enrichHighlightsData(){
        this.profileDataService.researcherHighlights =  this.profileDataService.researcherHighlights.map(item => ( { ...item,
            author: this.profileAssetEnrichmentService.getAuthor(item),
            type: this.profileAssetEnrichmentService.getType(item), isPartOf: this.profileAssetEnrichmentService.getIsPartOf(item),
            href: this.getHref(item),
            doi: item.doi, isReservedDOI: item.isReservedDOI, date: this.profileAssetEnrichmentService.getDateByPriority(item)} ));
        this.profileDataService.researcherHighlights = this.profileDataService.researcherHighlights.map(item => ( { ...item,
            lines: this.profileAssetEnrichmentService.getLines(item)} ));
    }

    getHref(item){
        return this.profileAssetEnrichmentService.getDiscoveryURL(item.mmsId, this.institutionCode);
    }

}
